import { Actions } from 'vuex-smart-module';
import CartDetailGetters from './getters';
import CartDetailMutations from './mutations';
import CartDetailState from './state';
import { CartService } from '../../../services';

const cartService = new CartService();

export default class CartDetailActions extends Actions<
  CartDetailState,
  CartDetailGetters,
  CartDetailMutations,
  CartDetailActions
> {
  async get_cart_detail(id: string | number) {
    try {
      const { data } = await cartService.get_cart_detail(id);

      this.mutations.SET_CURRENT_CART(data);
    } catch (error) {
      console.log(error);
    }
  }

  async retry_cart(id: number) {
    try {
      await cartService.retry_cart(id);
    } catch (error) {
      console.log(error);
    }
  }
}
